import { Flex, Tag } from "antd";
import BaseImage from "components/BaseImage";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const ClassCard = ({
  classInfo,
  showCreator,
}: {
  classInfo: Class.FullInfo;
  showCreator?: boolean;
}) => {
  const navigate = useNavigate();
  return (
    <Flex vertical justify="space-between" className="class-card" gap="small">
      <Flex vertical gap="small">
        <span className="name">{classInfo?.classroom_name}</span>
        <span className="description">{classInfo?.description}</span>
        <Flex gap="small">
          {classInfo?.user_count !== undefined && (
            <Tag color="#55acee">{`${
              classInfo.user_count + 1
            } thành viên`}</Tag>
          )}
          <Tag color="#55acee" style={{ width: "fit-content" }}>
            {`${classInfo?.quiz_count} học phần`}
          </Tag>
        </Flex>
      </Flex>
      {showCreator && (
        <Flex
          gap="small"
          align="center"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/users/${classInfo?.creator?._id}`);
          }}
          className="creator-container"
        >
          <BaseImage
            className="avatar"
            src={classInfo?.creator?.avatar}
            width={32}
            height={32}
          />
          <span>{classInfo?.creator?.name || "user"}</span>
        </Flex>
      )}
    </Flex>
  );
};

export default ClassCard;
